import React from 'react';

const MarketingPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-h2 text-ui-text">Marketing</h1>
    </div>
  );
};

export default MarketingPage;
